import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { completeSsoLogin } from '../../../../services/auth';
import { consumePostLoginRedirect } from '../../../../services/authPostLoginRedirectStorage';
import '../../../molecules/AuthSupportCard.css';
import LiquidGlassCard from '../../../molecules/LiquidGlassCard';
import MusicalAnimatedBackground from '../../../organisms/Background/MusicalAnimatedBackground/MusicalAnimatedBackground';
import './index.css';

const resolveSsoErrorMessage = (error, t) => {
  const code = error?.response?.data?.code;

  if (code === 'ACCOUNT_EXISTS_REQUIRES_LINKING') {
    return t('auth.login.sso.accountExists');
  }
  return t('auth.login.sso.error');
};

const SsoCallbackPage = () => {
  const { provider } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const normalizedProvider = (provider || '').toLowerCase();
    if (!['google', 'apple'].includes(normalizedProvider)) {
      setStatus('error');
      setErrorMessage(t('auth.login.sso.invalidProvider'));
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error) {
      setStatus('error');
      setErrorMessage(t('auth.login.sso.error'));
      return;
    }

    if (!code || !state) {
      setStatus('error');
      setErrorMessage(t('auth.login.sso.missingParams'));
      return;
    }

    dispatch(completeSsoLogin(normalizedProvider, code, state))
      .then(() => {
        setStatus('success');
        navigate(consumePostLoginRedirect(), { replace: true });
      })
      .catch((requestError) => {
        setStatus('error');
        setErrorMessage(resolveSsoErrorMessage(requestError, t));
      });
  }, [dispatch, navigate, provider, t]);

  return (
    <div className="sso-callback-page">
      <MusicalAnimatedBackground />
      <div className="sso-callback-container">
        <LiquidGlassCard
          title={t('auth.common.brand')}
          variant="auth"
          size="medium"
          className="sso-callback-card"
        >
          {status === 'loading' && <p>{t('auth.login.sso.processing')}</p>}
          {status === 'error' && (
            <>
              <p className="sso-error">{errorMessage}</p>
              <div className="auth-footer sso-callback-footer">
                <Link to="/login">{t('auth.login.sso.backToLogin')}</Link>
              </div>
            </>
          )}
        </LiquidGlassCard>
      </div>
    </div>
  );
};

export default SsoCallbackPage;
